// @flow

import React, { useEffect } from "react";
import { localize } from "redux-i18n";

import type { HierarchyTree } from "@modules/shared/reducer/hierarchy/types";
import actionCreators from "@modules/service/actionCreator";
import type { StepProps } from "@components";
import { View } from "@components";
import type { HierarchyAssignment } from "@modules/service/types";
import { HierarchyScopeForm } from "@modules/service/components";

type OwnProps = $Exact<{
  editing: boolean,
  hierarchy: ?HierarchyTree,
  assignments: Array<HierarchyAssignment>,
  onChange: Function,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...StepProps,
  ...PropsFromLocalize,
}>;

export function StepAssignments({ hierarchy, editable, editing, assignments, onChange }: Props) {
  useEffect(() => {
    editing && onChange({ assignments: assignments }, true);
  }, []);

  function handleChange(data: Array<HierarchyAssignment>) {
    onChange({ assignments: data }, true);
  }

  return !editable ? (
    <View />
  ) : (
    <View>
      {hierarchy && assignments && (
        <HierarchyScopeForm
          hierarchy={hierarchy}
          assignments={assignments}
          onChange={handleChange}
        />
      )}
    </View>
  );
}

export default localize()(StepAssignments);
